<template>
  <footer class="modern-footer py-4 mt-auto">
    <div class="container-fluid px-4">
      <div
        class="d-flex align-items-center justify-content-between footer-text"
      >
        <div class="text-muted small">
          &copy;
          {{
            new Date().getFullYear() == "2026"
              ? "2026"
              : new Date().getFullYear()
          }}
          <strong>SIBUNAK</strong> • Pemerintah Sulawesi Tengah
        </div>
        <div class="footer-links">
          <span class="badge bg-soft-primary">v1.0.0</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FootBar",
};
</script>

<style scoped>
.modern-footer {
  background: #ffffff; /* Beri warna background agar tidak transparan saat menabrak konten */
  border-top: 1px solid #f1f5f9;
  width: 100%;
  /* Jangan gunakan position absolute di sini */
}

.footer-text {
  font-size: 0.85rem;
}

.bg-soft-primary {
  background-color: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 6px;
}
</style>